export enum ChatStatuses {
    CREATED = 0,
    TRAVEL_MANAGER_ASSIGNED = 1,
    TRAVEL_MANAGER_REQUESTED_TRIP_CONFIRMATION = 2,
    TRIP_FINALIZED = 3,
}

export type Chat = {
    pk: string
    trip_id: string
    travel_initiator: string
    travel_manager?: string
    participants: Array<string>
    removed_participants: Array<string>
    status: ChatStatuses
}
